import { Button, DataTable, ResultsCard, ResultsToolbar } from 'shared/components/ui';
import React, { useState, useEffect } from 'react';
import { Save } from '@mui/icons-material';

import { rolesAPI } from '../services/rolesAPI';
import { ToastContainer } from '../../../shared/components';
import './TablaRoles.css';

const TablaRoles = ({ roles, estadosTurno, loading, onSave }) => {
  const [permisos, setPermisos] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const initialPermisos = {};
    roles.forEach(rol => {
      initialPermisos[rol.id] = rol.estadosPermitidos || [];
    });
    setPermisos(initialPermisos);
    setHasChanges(false);
  }, [roles]);

  const handleToggleEstado = (rolId, estadoId) => {
    setPermisos(prev => {
      const rolPermisos = prev[rolId] || [];
      const newPermisos = rolPermisos.includes(estadoId)
        ? rolPermisos.filter(id => id !== estadoId)
        : [...rolPermisos, estadoId];
      
      setHasChanges(true);
      return { ...prev, [rolId]: newPermisos };
    });
  };

  const handleGuardarCambios = async () => {
    setSaving(true);
    try {
      await Promise.all(
        Object.entries(permisos).map(([rolId, estadosPermitidos]) =>
          rolesAPI.updatePermisos(parseInt(rolId), estadosPermitidos)
        )
      );
      setHasChanges(false);
      setToast({ message: 'Permisos actualizados correctamente', type: 'success' });
      if (onSave) onSave();
    } catch (error) {
      console.error('Error al guardar cambios:', error);
      setToast({ message: 'Error al guardar los cambios', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
      <ResultsCard className="results-card">
      <ResultsToolbar className="results-header">
        <div className="results-header-left">
          <h3 className="results-title">Permisos por Rol</h3>
          <span className="results-subtitle">Selecciona los estados de turno que cada rol puede visualizar</span>
        </div>
        <div className="results-info">
          <Button
            variant="success" 
            size="sm" 
            onClick={handleGuardarCambios}
            className="btn-save-changes"
            disabled={loading || !hasChanges || saving}
          >
            <Save sx={{ fontSize: 18, mr: 0.5 }} />
            {saving ? 'Guardando...' : 'Guardar Cambios'}
          </Button>
        </div>
      </ResultsToolbar>

      <div className="table-container">
        <DataTable className="data-table roles-table">
          <tbody>
            <tr>
              <th className="rol-column">Rol</th>
              {roles.map(rol => (
                <td key={rol.id} className="rol-name">{rol.nombre}</td>
              ))}
            </tr>
            {estadosTurno.map(estado => (
              <tr key={estado.idEstadoTurno}>
                <th className="estado-column">{estado.estadoTurno}</th>
                {roles.map(rol => (
                  <td key={rol.id} className="checkbox-cell">
                    <input
                      type="checkbox"
                      className="estado-checkbox"
                      checked={permisos[rol.id]?.includes(estado.idEstadoTurno) || false}
                      onChange={() => handleToggleEstado(rol.id, estado.idEstadoTurno)}
                      disabled={loading || saving}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </DataTable>
      </div>
    </ResultsCard>
    </>
  );
};

export default TablaRoles;
